import imgNamee91 from "./img-namee9 (1).webp";
import imgNamee92 from "./img-namee9 (2).webp";
import imgNamee93 from "./img-namee9 (3).webp";
import imgNamee94 from "./img-namee9 (4).webp";

const imgNamee9 = [imgNamee91, imgNamee92, imgNamee93, imgNamee94];

export default imgNamee9;
